export default __webpack_public_path__ + "static/media/goshen73.037e8cfa.jpg";